import styled from "styled-components";
import Block from "components/layout/Block";
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledModalMainSection = styled(Block)`
	position: relative;
	z-index: 1;
	background-color: black;
	flex-grow: 1;
	color: ${({ theme: { colors } }) => colors.whiteTrue};
	height: 100%;
	width: 100%;

	@media (max-width: ${breakpoints.desktop - 1}px) {
		min-height: 100dvh;
		padding: 0.5rem 1rem;
	}

	@media (max-width: ${breakpoints.phone - 1}px) {
		min-height: 100dvh;
		padding: 0.5rem 0;
	}

	@media (min-width: ${breakpoints.desktop}px) {
		min-height: 0;
		padding: 1rem 1rem 0.5rem;
		border-top-left-radius: ${({ theme: { borderRadius } }) =>
			borderRadius.card};
		border-bottom-left-radius: ${({ theme: { borderRadius } }) =>
			borderRadius.card};
	}
`;

// #####################################################
